import React from 'react';
import { AddNewSite } from '../../merchants/sites/AddNewSite';
import { ISitesProps } from '../../../views/merchants/details/MerchantSitesPage';
import { IAuthState } from '../../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { parseJwt } from '../../../views/login/Login';

interface Props {
	siteInfo: ISitesProps,
}

export const SiteInformation = (props: Props): React.ReactElement => {
	const { siteInfo } = props;
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const user = parseJwt(authUser.idToken);
	const mid = user?.['custom:mid'];

	return (
		<div className="card">
			<div className="card-body">
				<AddNewSite merchantId={mid} chosenSite={siteInfo}/>
			</div>
		</div>
	);
};
